import styled from 'styled-components';
import { Props } from './index';

export const Wrapper = styled.div<Props>`
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@500;600&display=swap');
  display: flex;
  align-items: center;
  background-color: ${({ variant }: Props) =>
    variant === 'success' ? '#38B449' : '#FFB000'};
  color: ${({ variant }: Props) =>
    variant === 'success' ? '#FFFFFF' : '#000000E0'};
  padding: 16px 19px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 24px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  flex: 1;
  width: 100%;
  border-radius: 4px;
  transition: all 0.2s;

  & p {
    margin: 0;

    a {
      color: #000000e0;
    }
  }

  & div svg {
    margin-right: 19px;
    display: flex;
    align-items: center;
  }
`;
